exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-24973c23] .bot-table {\n  border: none;\n  box-shadow: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/project/project.list.vue?vue&type=style&index=0&id=24973c23&lang=stylus&scoped=true&
// module id = 748
// module chunks = 2